/**
 * Every piece of interface German that is NOT migrated content.
 *
 * Migrated copy lives in src/content/*.json and is never retyped. The strings
 * below are new chrome the rebuild needs (filter labels, form states, empty
 * states). They are collected here so they can be reviewed in one place.
 */
export const UI = {
  skipToContent: 'Zum Inhalt springen',
  menuOpen: 'Menü öffnen',
  menuClose: 'Menü schliessen',
  mainNav: 'Hauptnavigation',
  mobileNav: 'Mobile Navigation',
  footerNav: 'Fussbereich',
  legalNav: 'Rechtliches',
  breadcrumb: 'Sie sind hier',
  home: 'Startseite',

  utilityNav: 'Servicenavigation',
  toHome: 'Zur Startseite',
  contact: 'Kontakt',
  navSubmenu: (label: string) => `Untermenü ${label}`,
  navAllScreenings: 'Alle Screenings',
  navOverviewGenetic: 'Übersicht Genetic Sciences',
  footerServices: 'Leistungen',
  footerCompany: 'Unternehmen',

  filterLabel: 'Filter',
  filterAll: 'Alle',
  resultsOne: 'Ein Ergebnis',
  resultsMany: (n: number) => `${n} Ergebnisse`,
  resultsNone: 'Keine Ergebnisse',

  readMore: 'Weiterlesen',
  publishedOn: 'Veröffentlicht am',
  categories: 'Kategorien',
  tags: 'Schlagwörter',

  chartTableToggle: 'Daten als Tabelle',
  chartLabel: (title: string) => `Diagramm: ${title}`,

  formRequired: 'Pflichtfeld',
  formChoose: 'Bitte wählen',
  formSending: 'Wird gesendet …',
  formSuccess: 'Vielen Dank. Wir melden uns bei Ihnen.',
  formError:
    'Das Formular konnte nicht gesendet werden. Bitte kontaktieren Sie uns direkt per E-Mail oder Telefon.',

  instagramPlaceholder: 'Instagram-Feed',

  /**
   * The reference logo wall. `logoWall` is the accessible name of the list and
   * is the page's own title, not new copy. `logoWallNote` is a trademark
   * notice: it states ownership only and makes no claim of partnership,
   * endorsement or certification.
   */
  logoWall: 'Referenzen',
  logoWallNote: 'Alle Marken- und Firmenlogos sind Eigentum der jeweiligen Inhaber.',

  notFoundTitle: 'Seite nicht gefunden',
  notFoundBody: 'Die aufgerufene Seite existiert nicht oder wurde verschoben.',
  notFoundAction: 'Zur Startseite',

  /* --- Section eyebrows and slot labels (design.md 8) -------------------- *
   * These are labels the blueprints put above migrated headings. They name a
   * section; they never restate one. Where a blueprint's slot is filled by a
   * source string, the string is read from the content layer instead.        */
  eyebrowPositioning: 'BGM Schweiz',
  eyebrowReferences: 'Referenzen',
  eyebrowApproach: 'Unser Ansatz',
  eyebrowTrust: 'Vertrauen',
  eyebrowScreenings: 'Screenings',
  eyebrowLegal: 'Rechtliches',
  eyebrowNews: 'News',
  eyebrowAbout: 'Über Uns',
  eyebrowPledges: 'Sechs Zusagen',

  heroSecondary: 'Screenings ansehen',
  allReferences: 'Alle Referenzen',
  moreOnDataSecurity: 'Mehr zur Datensicherheit',
  complianceDossier: 'Zum Compliance-Dossier',
  moreScreenings: 'Weitere Screenings',
  morePosts: 'Weitere Beiträge',
  learnMore: 'Mehr erfahren',
  learnMoreAbout: (title: string) => `Mehr erfahren: ${title}`,

  filterScreenings: 'Screenings filtern',
  filterCount: (shown: number, total: number) => `${shown} von ${total} Screenings`,
  filterMissing: 'Filter nicht gefunden, alle Screenings werden angezeigt.',

  tocTitle: 'Inhalt',
  topicsTitle: 'Themen',
  sidebarContactTitle: 'Fragen zu Screenings?',

  pagination: 'Seiten',
  paginationPrev: 'Zurück',
  paginationNext: 'Weiter',
  paginationPage: (n: number) => `Seite ${n}`,

  linkedInOf: (name: string) => `${name} auf LinkedIn`,

  archiveCategory: 'Kategorie',
  archiveTag: 'Schlagwort',
  archiveAuthor: 'Autor',
  archivePortfolioCategory: 'Screening-Kategorie',
  portfolioIndexTitle: 'Screenings',
  newsIndexTitle: 'News',
} as const;
